import React from 'react'
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import { ROUTES } from '../../Constants'
import { EventHub } from '../../Views/EventHub'
import Proposal from '../../Views/Proposal'
import AllProposals from '../../Views/AllProposals'
import RequestSuccess, { RequestSuccessV2 } from '../../Views/RequestSuccess'

export const Router = (): JSX.Element => (
  <BrowserRouter basename='/smart-book-events'>
    <Switch>
      <Route path={ROUTES.EVENT_HUB} exact>
        <EventHub />
      </Route>
      <Route path={`${ROUTES.PROPOSAL}/:proposalUUID`}>
        <Proposal />
      </Route>
      <Route path={`${ROUTES.ALL_PROPOSALS}/:eventUUID`}>
        <AllProposals />
      </Route>
      <Route path={ROUTES.CONFIRMATION}>
        <RequestSuccess />
      </Route>
      <Route path={ROUTES.CONFIRMATION_V2}>
        <RequestSuccessV2 />
      </Route>
      <Redirect to={ROUTES.EVENT_HUB} />
    </Switch>
  </BrowserRouter>
)
